const PasswordCheck = {
  specialcharacter (string) {
    var format = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/
    if (format.test(string)) {
      return true
    } else {
      return false
    }
  },
  lowercaseCheck (string) {
    return string.toUpperCase() !== string
  },
  uppercaseCheck (string) {
    return string.toLowerCase() !== string
  },
  numberCheck (string) {
    var format = /\d/g
    if (format.test(string)) {
      return true
    } else {
      return false
    }
  },
  minCharacterCheck (string) {
    if (string.length >= 8) {
      return true
    } else {
      return false
    }
  }
}

export default PasswordCheck
